const layout = {
  maxPageWidth: 1280,

  radius: {
    none: 0,
    xs: 2,
    sm: 4,
    md: 6,
    lg: 8,
    xl: 16,
    rounded: 1000
  },

  spacing: {
    s000: 0,
    s100: 2,
    s200: 4,
    s300: 8,
    s400: 12,
    s500: 16,
    s600: 24,
    s700: 32,
    s800: 40,
    s900: 48
  }
}

export default layout
